import {observable, action, computed} from 'mobx';
import {paths} from '../App';


let instance = null

export class Store {
  @observable eventFromOutSide;
  @observable twitter = true;

  disableTwitter(){
    this.twitter = false;
  }
  enableTwitter(){
    this.twitter = true;
  }
  @computed
  get isTwitterEnable(){
    return this.twitter;
  }

  finance = [{
    search: 'tab=day',
    label: 'Day',
  },{
    search: 'tab=week',
    label: 'Week',
  },{
    search: 'tab=month',
    label: 'Month',
  },{
    search: 'tab=year',
    label: 'Year',
  },{
    search: 'tab=date&from=:from&to=:to',
    label: 'Date',
  }];

   ///

  @observable cFinance = 0

  setCurrentFinance(name = 'Day'){
    if(!isNaN(name)){
      this.cFinance = name;
      return;
    }

    this.cFinance = this.finance.findIndex(tab => tab.label.toLowerCase() == name.toLowerCase() );

  }

  @computed
  get currentFinance(){
    return this.cFinance;
  }


  ///


  @observable currentAccountSellerInfo = null;

  setAccountSellerInfo(info = {}){
    this.currentAccountSellerInfo = info;
  }

  @computed
  get getAccountSellerInfo(){
    return this.currentAccountSellerInfo;
  }

  ///

  @observable currentAccountAffiliateInfo = null;

  setAccountAffiliateInfo(info = {}){
    this.currentAccountAffiliateInfo = info;
  }

  @computed
  get getAccountAffiliateInfo(){
    return this.currentAccountAffiliateInfo;
  }

  ///

  @observable
  impl2usd = '';

  @computed
  get getIMPL2USD(){
    return this.impl2usd;
  }

  setIMPL2USD(p){
    this.impl2usd = p;
  }

  viewSize = (view, type = 'vert') => {
    switch (view) {
      case 'view1':
        return type == 'vert' ? '300x450' : '300x250';
      case 'break1':
        return type == 'vert' ? '300' : '0';
      case 'view2':
        return type == 'vert' ? '300x450' : '300x250';
      case 'break2':
        return type == 'vert' ? '300' : '0';
      case 'view3':
        return type == 'vert' ? '300x450' : '300x250';
      case 'break3':
        return type == 'vert' ? '300' : '0';
      case 'view4':
        return type == 'vert' ? '400x300' : '400x300';
      case 'break4':
        return type == 'vert' ? '300' : '0';
      case 'view41':
        return type == 'vert' ? '400x300' : '400x300';
      case 'break41':
        return type == 'vert' ? '300' : '0';
      case 'view42':
        return type == 'vert' ? '400x300' : '400x300';
      case 'break42':
        return type == 'vert' ? '300' : '0';
      case 'view5':
        return type == 'vert' ? '300x500' : '500x230';
      case 'break5':
        return type == 'vert' ? '0' : '0';
      case 'view51':
        return type == 'vert' ? '300x500' : '500x230';
      case 'break51':
        return type == 'vert' ? '0' : '0';
      case 'view91':
        return type == 'vert' ? '210x350' : '500x230';
      case 'break91':
        return type == 'vert' ? '0' : '0';
      case 'view92':
        return type == 'vert' ? '400x450' : '860x230';
      case 'break92':
        return type == 'vert' ? '0' : '0';

      case 'view93':
        return type == 'vert' ? '280x100' : '280x100';
      case 'break93':
        return type == 'vert' ? '0' : '0';

      default:
        break;
    }
  }

  static clear(){
    instance.currentAccountAffiliateInfo = null;
    instance.currentAccountSellerInfo = null;
  }

}
if(!instance){
  instance = new Store
}


export default instance;
